"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    map: {
        path: "/map"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvbWFwcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIG1hcDoge1xuICAgIHBhdGg6IFwiL21hcFwiLFxuICB9LFxufSk7XG4iXSwibmFtZXMiOlsicm91dGVzIiwiYnVpbGRSb3V0ZXMiLCJtYXAiLCJwYXRoIl0sIm1hcHBpbmdzIjoiOzs7OytCQUVhQTs7O2VBQUFBOzs7dUJBRmU7QUFFckIsTUFBTUEsU0FBU0MsSUFBQUEsa0JBQVcsRUFBQztJQUNoQ0MsS0FBSztRQUNIQyxNQUFNO0lBQ1I7QUFDRiJ9